<app-help-page-banner [items]="" [returnAddress]="'/HelpPage'"></app-help-page-banner>
<div class="container">
    <!-- StartPage -->
    <h2>{{'Link Kundenportal' | translate}} </h2>
    <p>{{'Der Kundenportal Link (AIN Link) befindet sich oben rechts im Bild des Equipments:' | translate}}</p>
    <img id="imageCostumerPortal"
         src="{{environment.storageUrl}}/models3d/general/helpPage/introduction/LinkCustomerPortal/LinkCostumerPortal_{{urlLanguage}}.png"
         class="embed-responsive mx-auto d-block">
</div>
